import React from 'react';
import { useLoaderData } from 'react-router';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';


const Statics = () => {
    const chartData = useLoaderData();
    const { data } = chartData;
    const { name, total } = data;
    return (
        <div className='w-3/4 md:w-full h-auto mt-5 py-10 text-center text-white bg-black'>
            <h1 className='m-10 text-4xl text-bold'>Simple Statices Of the Topics</h1>
            <div className='flex justify-center'>
                <LineChart width={1000} height={400} data={data}>
                    <Line type="monotone" dataKey="total" stroke="#82ca9d" />
                    <XAxis dataKey="name" />
                    <YAxis />
                    <Tooltip></Tooltip>
                </LineChart>
            </div>
        </div>
    );
};

export default Statics;